import {Injectable} from "@angular/core";
import {FormDataUpload, NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";

@Injectable()
export class StorageApi {

  private readonly service: string = '';
  private readonly model: string = 'storage';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public uploadSf6(file: File, path: string, configs: any, fileName?: string): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadSf6';
    const params: FormDataUpload[] = [];
    params.push(
      {name: 'file', value: file, ...(fileName && {fileName})},
      {name: 'path', value: path},
      {name: 'configs', value: configs},
    );
    const urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, _url, params);
  }

  public uploadToSF6(file: File, uploadCode: string, rename: string, fileName?: string): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadSf6';
    const params: FormDataUpload[] = [];
    params.push(
      {name: 'file', value: file, ...(fileName && {fileName})},
      {name: 'fileName', value: rename},
      {name: 'uploadCode', value: uploadCode},
    );
    const urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, _url, params);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/storage.api.ts